export default {
  handleEWCompleted: () => {},

  handleFirstBackButton: () => {},

  handleNextCallback: () => {},

  handleBackCallback: () => {}
};